import React from "react";
import {LayoutAuthWithForm} from "../../../layouts";
import {AuthInput, AuthPwdInput} from "../../../helpers/InputsHelpers";
import {Box} from "@material-ui/core";
import trim from "mn-utils/trim";
import {object, string} from "yup";
import {account$, getUserMainPage, onAccount} from "../../../../emitters/account";
import toLower from "mn-utils/toLower";
import {Link, replaceLocation} from "../../../../router";
import {LINK_BLOCKED, LINK_FORGOT_PASSWORD, LINK_SECURITY_VERIFICATION, LINK_START} from "../../../../constants/links";

export default () => {
  React.useEffect(() => {
    const account = account$.getValue();

    if (!account.id) return;

    replaceLocation({
      path: account.blocked
        ? LINK_BLOCKED
        : account.need_tfa
          ? LINK_SECURITY_VERIFICATION
          : getUserMainPage(),
    })
  }, []);


  const data = {email: localStorage.getItem('email') || ''};

  const schema = object({
    email: string().isValidEmail().required(),
    password: string()
      .isValidOldPwd()
      .isValidPwdLength()
      .withoutCyrillicSymbols()
      .required()
  });

  const onSubmit = (data) => (
    account$.signIn({
      email: data.email,
      password: data.password,
    })
  );

  const onResult = (account) => {
    if (account.blocked) {
      replaceLocation({
        path: LINK_BLOCKED + '/' + encodeURIComponent(data.email) + '/',
      });
      return;
    }
    if (onAccount(account)) {
      return;
    }
    replaceLocation({
      path: getUserMainPage(),
    });
  };


  return (
    <LayoutAuthWithForm
      title="Login"
      formProps={{
        schema,
        data,
        onSubmit,
        onResult
      }}
      content={(formCtx) => (
        <>
          <AuthInput
            name="email"
            formCtx={formCtx}
            onChangeHandlers={[
              trim,
              toLower,
              (val) => {
                localStorage.setItem('email', val)
                return val;
              }
            ]}
          />
          <Box mt="3rem">
            <AuthPwdInput
              name="password"
              formCtx={formCtx}
              onChangeHandlers={[trim]}
            />
          </Box>
        </>
      )}
      beforeFooter={(
        <Link
          href={LINK_FORGOT_PASSWORD}
          className="c5B47FF olN tdU dn f12 fw3 o70:h"
        >Forgot password?</Link>
      )}
      submitBtnText="Sign in"
      additional={(
        <>
          <span className="pr12 f12 fw3 lh lts0em">
            Don’t have an account?
          </span>
          <span className="st-2 wmin72">
            <Link
              xhref={LINK_START}
              href="/start"
              className="c5B47FF olN tdU dn f16 fw3 o70:h"
            >Sign up</Link>
          </span>
        </>
      )}
    />
  )
}
